<!-- Group -->
<div class="column-group">
  <div class="column-group__header">
    <ng-content select="[column-group-header]"></ng-content>
  </div>
  <div class="column-group__body">
    <ng-content select="[column-group-body]"></ng-content>
  </div>
</div>